import React, { useEffect, useRef, useState } from 'react';
import MaterialTable, { MTableToolbar } from 'material-table';
import TablePagination from '@material-ui/core/TablePagination';
import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline';
import { Karte } from 'openapi';

import ProcessingContainer from "../../containers/Processing";
import DateTimePicker from '../inputs/DateTimePicker';
import CompleteProcessDialog from '../dialogs/CompleteProcessDialog';

interface Props {
  onQueryChange?: (date: Date, page: number, pageSize: number) => void,
  isLoading: boolean,
  showToolbar: boolean,
  showDateTimePicker: boolean,
  showPaging: boolean,
}

export default ((props) => {

  const processingContainer = ProcessingContainer.useContainer();
  const [selectedKarte, setSelectedKarte] = useState<Karte | undefined>(undefined);
  const tableRef = useRef(null);

  const now = new Date();
  const utc = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());

  const [selectedDate, setSelectedDate] = React.useState<Date>(new Date(utc));
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(5);

  if (props.showDateTimePicker) {
    useEffect(() => {
      props.onQueryChange && props.onQueryChange(selectedDate, page, pageSize);
    }, [selectedDate, page, pageSize]);
  }

  const handleSelectedDateChange = (date: Date | null) => {
    if (date) {
      setSelectedDate(date);
    }
  };

  return (
    <>
      <MaterialTable
        title="Processing List"
        tableRef={tableRef}
        isLoading={props.isLoading}
        onChangeRowsPerPage={(pageSize) => setPageSize(pageSize)}
        components={{
          Toolbar: innerProps => (
            <>
              {props.showToolbar &&
                <div>
                  <MTableToolbar {...innerProps} />
                  {props.showDateTimePicker && <DateTimePicker date={selectedDate} onSelectedDateChange={handleSelectedDateChange} />}
                </div>}
            </>
          ),
          Pagination: props => (
            <>
              <TablePagination
                {...props}
                onChangePage={(event, page) => setPage(page)}
                page={page}
                count={processingContainer.total} />
            </>
          ),
        }}
        columns={[
          { title: 'KarteNo', field: 'karteNo', type: 'numeric' },
          { title: 'StoreNo', field: 'storeCode', type: 'numeric' },
          { title: 'BuyDate', field: 'createdDate', type: 'date' },
          { title: 'CustomerNo', field: 'customerNo' },
          { title: 'CustomerName', field: 'name' },
          { title: 'L LensName', field: 'leftLensName' },
          { title: 'R LensName', field: 'rightLensName' },
          { title: 'FrameName', field: 'frameName' },
        ]}
        data={processingContainer.kartes}
        options={{
          search: false,
          sorting: false,
          filtering: false,
          actionsColumnIndex: -1,
          paging: props.showPaging,
          pageSize: pageSize,
        }}
        actions={[
          rowData => ({
            icon: () => {
              const color = (!rowData.processings || rowData.processings.length === 0) ? 'action' : undefined;

              return <>
                <CheckCircleOutline color={color} htmlColor={'#00B900'} />
              </>
            },
            tooltip: 'Complete Processing',
            onClick: (event, data) => setSelectedKarte(data as Karte),
          }),
        ]}
      />
      <CompleteProcessDialog karte={selectedKarte} onClose={() => setSelectedKarte(undefined)} />
    </>
  );
}) as React.FC<Props>;
